/** * 基础菜单 商品管理 */
<template>
  <div v-loading="loading" class="mylout">
    <div v-for="(bXyWapHome, index) in pageHome" :key="index">
      <!-- 轮播图start -->
      <el-carousel class="carouselBox" trigger="click" height="490px" v-if="bXyWapHome.ascription == 1">
        <el-carousel-item v-for="(item, index) in bXyWapHome.column" :key="index">
          <a :href="item.url" target="_blank" v-if="item.url">
            <el-image class="bgo_home_image" :src="`${item.picimg}`" fit="fill" style="width: 100%; height: auto">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </a>
          <el-image class="bgo_home_image" v-else :src="`${item.picimg}`" fit="fill" style="width: 100%; height: auto;">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <!-- 轮播图end -->

      <!-- 通知轮播start -->
      <div class="shop_new" v-if="bXyWapHome.ascription == 13">
        <div class="sy_c">
          <div class="sy_gg">
            <div class="shop_new_logo">
              <div class="shop_new_text">{{$t('index.Latest Announcement')}}</div>
            </div>
            <div class="ranklist">
              <el-carousel direction="vertical" :interval="2000" class="notice_div" indicator-position="none">
                <el-carousel-item v-for="item in notice_list" :key="item">
                  <router-link :to="`siteHelpDetail?itemId=${item.articleId}`" :underline="false" :title="item.articleTitle">{{ item.articleTitle }}</router-link>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="new_more">
              <el-button @click="$router.push('/siteHelp?articleId=2&categoryId=8')" type="danger" icon="el-icon-more" size="small" :title="$t('index.More')"></el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 通知轮播 end -->

      <!-- 热门分类层start -->
      <div class="w w1200" v-if="bXyWapHome.ascription == 13">
        <el-row :gutter="20" style="margin: 0 0">
          <el-col class="channel-column" :span="5" v-for="(item, index) in list_hot_Category" :key="index + '_hot'" :style="
              'background:url(' +
              require('../../assets/images/channel_bg' + (index + 1) + '.jpg') +
              ') no-repeat;'
            ">
            <div class="column-title">
              <h3 style="color: white;">{{ item.name }}</h3>
              <p>{{ item.remark }}</p>
            </div>
            <div class="column-img">
              <el-image :src="`${item.icon}`" fit="fill">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <router-link :to="`/goodsList?page=home&bxscId=${item.bxscId}&bxscName=${item.name}`" class="column-btn">{{$t('index.go and see')}}
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 热门分类层end -->

      <!--  一行三个图片 模板1105 开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 2">
        <h4 class="floor_title" style="color: #666;" v-if="bXyWapHome.enable==0||bXyWapHome.enable=='0'">
          {{ bXyWapHome.modelClass!=null? bXyWapHome.modelClass : $t('index.Template 1105_Title')}}
        </h4>
        <div class="block onethreeImg1">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img :src="bXyWapHome.column[0].picimg==null?'':bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img :src="bXyWapHome.column[1].picimg==null?'':bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img :src="bXyWapHome.column[2].picimg==null?'':bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

      <!--  一行三个图片 模板1111开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 8">
        <h4 class="floor_title" style="color: #666;" v-if="bXyWapHome.enable==0||bXyWapHome.enable=='0'">
          {{ bXyWapHome.modelClass!=null? bXyWapHome.modelClass : $t('index.Template 1111_Title')}}
        </h4>
        <div class="block onethreeImg2">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img :src="bXyWapHome.column[0].picimg==null?'':bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img :src="bXyWapHome.column[1].picimg==null?'':bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img :src="bXyWapHome.column[2].picimg==null?'':bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

      <!--  模板12 广告位 开始 -->
      <div class="wrap1 clearfix god-wrapper" v-if="bXyWapHome.ascription == 12">
        <div class="area">
          <span class="god-mark">{{$t('index.advertise')}}</span>
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <div>
              <img :src="bXyWapHome.column[0].picimg">
            </div>
          </router-link>
        </div>
      </div>
      <!--  模板12 广告位 结束 -->

      <!-- 模板1 start 美丽人生--模板1110-->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 7">
        <h4 class="floor_title">
          <a href="javascript:;">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : $t('index.Template 1110_Title')}}</a>
        </h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null?bXyWapHome.column[1].name:$t('index.Template 1110_right mark 1') }}
          </router-link>
          <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
            {{bXyWapHome.column[2].name != null ? bXyWapHome.column[2].name:$t('index.Template 1110_right mark 2')}}
          </router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_second">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <!-- :onerror="defaultImg" -->
              <img alt="广告图片1" :src="bXyWapHome.column[3].picimg!=null?bXyWapHome.column[3].picimg:''" style="display: inline" />
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[4].picimg!=null?bXyWapHome.column[4].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <img :src="bXyWapHome.column[5].picimg!=null?bXyWapHome.column[5].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[6].picimg!=null?bXyWapHome.column[6].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[7].picimg!=null?bXyWapHome.column[7].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[8].picimg!=null?bXyWapHome.column[8].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="max_goods" :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[9].picimg!=null?bXyWapHome.column[9].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[10].picimg!=null?bXyWapHome.column[10].picimg:''" style="display: inline" />
            </router-link>
          </div>
        </div>
      </div>
      <!-- 模板1 end -->
      <!-- 限时秒杀 v-if="bXyWapHome.ascription==3"-->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 3">
        <el-row :gutter="20">
          <el-col :span="5">
            <div class="grid-content">
              <el-image :src="kill_image">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-col>
          <el-col :span="19">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(killgoods,index) in bXyWapHome.column" :key="killgoods">
                <div class="grid-content bg-purple" v-if="index>0&&killgoods.commodity!=null">
                  <router-link :to="`/goodsdetail?id=${killgoods.url}`">
                    <div class="skill_act_pic">
                      <el-image :src="killgoods.picimg" class="bg">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </div>
                  </router-link>
                  <div class="skill_act_name">
                    {{killgoods.commodity==null||killgoods.commodity==''?'---':killgoods.commodity.name}}
                  </div>
                  <div class="skill_act_price">
                    <span class="act_now_price">
                      <i>¥</i>
                      <span>???</span>
                    </span>
                    <span class="act_old_price">
                      <i>¥</i>
                      <span>{{killgoods.commodity==null||killgoods.commodity==''?'0':killgoods.commodity.marketprice}}</span>
                    </span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <!-- 拼团楼层 -->
      <!-- <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 4">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content-spell bg-purple">
              <div class="spell_goods_pic">
                <el-image
                  src="http://47.97.97.45/test/image.php/shop/data/upload/media/store/1003/image/20180710/1531209987736030.jpg"
                  class="bg">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="act_info">
                <p>距离本场结束</p>
                <p><span class="day">89</span><strong> 天</strong> <span class="hour">00</span><strong> 时</strong> <span
                    class="mini">58</span><strong> 分</strong> <span class="sec">21</span><strong> 秒</strong></p>
                <p class="buy_cart"></p>
              </div>
              <div class="pname">
                <p class="name">雅诗兰黛小棕瓶面部精华 特润修护肌透精华露30ml 修护 </p>
                <p class="price"><i>¥</i>49.90</p>
              </div>
              <div class="percentBar">
                <div class="barWrap"><b style="width: 50%;"></b></div>
                <div style="    margin-top: 2px;">
                  <p class="fl">限量3000件</p>
                  <p class="fr">剩余50%</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <!-- 模板1108 -->
      <div class="wrap1 floor_style_first clearfix" v-if="bXyWapHome.ascription == 5">
        <div class="mt fn-clear">
          <div class="floor_title">
            <router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1108_标题'}}</router-link>
          </div>
          <div class="floor_hotcat">
            <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '右侧标题'}}</router-link>
          </div>
        </div>
        <div class="mc fn-clear">
          <div class="floor_content">
            <div class="floor_banner">
              <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
                <img alt="广告图片" :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''" style="display: inline-block;">
              </router-link>
            </div>
            <div class="floor_goods">
              <div class="block">
                <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
            </div>
            <div class="floor_cat">
              <div class="block">
                <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[8].picimg!=null? bXyWapHome.column[8].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[9].picimg!=null? bXyWapHome.column[9].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
                  <img alt="广告图片" :src="bXyWapHome.column[10].picimg!=null? bXyWapHome.column[10].picimg : ''" style="display: inline-block;">
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 楼层模板1112 -->
      <div class="wrap1 floor_style_third clearfix" v-if="bXyWapHome.ascription == 9">
        <h4 class="floor_title">
          <router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1112_标题'}} </router-link>
        </h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '模板1108_标题'}}</router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_third">
            <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img alt="广告图片1112" :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg:''">
            </router-link>
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg:''">
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg:''">
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg:''">
            </router-link>
            <router-link class="last_item max_goods" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg:''">
            </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1113 -->
      <div class="wrap1 floor_style_fourth clearfix" v-if="bXyWapHome.ascription == 10">
        <h4 class="floor_title">
          <router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1113_标题'}}</router-link>
        </h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '右标题'}}</router-link>
        </div>
        <div class="floor_content">
          <div class="banner1">
            <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''" style="display: inline;">
            </router-link>
          </div>
          <div class="banner2">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <div class="last_item">
                <img alt="广告图片" :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''">
              </div>
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <div class="last_item">
                <img alt="广告图片" :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''">
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1114 -->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 11">
        <el-row :gutter="12">
          <el-col :span="4" v-for="(item, index) in bXyWapHome.column" :key="index" style="width:19.8%">
            <router-link :to="item.url!=null?item.url:''">
              <div class="grid-content-1114 bg-purple">
                <div class="goods_pic_1114">
                  <el-image :src="item.picimg" class="bg">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 模板2 start -->

      <!-- <div class="wrap1 floor_style_fourth clearfix"  v-if="bXyWapHome.ascription==4">
            <h4 class="floor_title">
              <a>{{bXyWapHome.name}}</a
              >
            </h4>
            <div class="floor_hotcat">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=436"
                >蓝牙</a
              >
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=438"
                >腕机</a
              >
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=440"
                >相机</a
              >
            </div>
            <div class="floor_content">
              <div class="banner1">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[0].id}`"
                  ><img
                   alt="广告图片"
                     :src="bXyWapHome.column[0].url"
                    style="display: inline"
                /></router-link>
              </div>
              <div class="banner2">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[1].id}`"
                  ><img
                   alt="广告图片"
                    :src="bXyWapHome.column[1].url"
                    style="display: inline"
                /></router-link>
              </div>
              <div class="floor_goods">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[2].id}`"
                  ><img
                    alt="广告图片"
                     :src="bXyWapHome.column[2].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  class="last_item"
                  :to="`/goodsdetail?id=${bXyWapHome.column[3].id}`"
                  ><img
                    alt="广告图片"
                     :src="bXyWapHome.column[3].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  :to="`/goodsdetail?id=${bXyWapHome.column[4].id}`"
                  ><img
                    alt="广告图片"
                    :src="bXyWapHome.column[4].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  class="last_item"
                   :to="`/goodsdetail?id=${bXyWapHome.column[5].id}`"
                  ><img
                  alt="广告图片"
                    :src="bXyWapHome.column[5].url"
                    style="display: inline-block"
                /></router-link>
              </div>
            </div>
          </div> -->
      <!-- 模板2  end -->

      <!-- 模板3  start -->
      <!-- <div class="wrap1 floor_style_first clearfix" v-if="bXyWapHome.ascription==5">
            <div class="mt fn-clear">
              <div class="floor_title">
                <a>{{bXyWapHome.name}}</a>
              </div>
              <div class="floor_hotcat">
                <a
                  href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006&amp;page=2"
                  >品牌闪购</a
                >
                <a
                  href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006"
                  >今日疯抢</a
                >
                <div>{{bXyWapHome.column[0].id}}</div>
              </div>
            </div>
            <div class="mc fn-clear">
              <div class="floor_content">
                
                <div class="floor_banner">
                  <router-link
                    :to="`/goodsdetail?id=${bXyWapHome.column[0].id}`"
                    ><img
                     alt="广告图片"
                     :src="bXyWapHome.column[0].url"
                      style="display: inline"
                  /></router-link>
                </div>
                <div class="floor_goods">
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[1].id}`"
                      ><img
                        alt="广告图片"
                       :src="bXyWapHome.column[1].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[2].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[2].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[3].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[3].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[4].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[4].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                </div>
                <div class="floor_cat">
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[5].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[5].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[6].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[6].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[7].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[7].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[8].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[8].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
      <!-- 模板3 end-->
    </div>
    <!-- 猜你喜欢 -->
    <!-- <div class="w1200_container">
      <div class="clear"></div>
      <favoritGoods stype='2'></favoritGoods>
    </div> -->

    <!-- 轮播图start -->
    <!-- <el-carousel class="carouselBox" trigger="click" height="500px">
      <el-carousel-item v-for="(item, index) in imgitems" :key="index">
        <el-image
          :src="`${item.url}`"
          fit="fill"
          style="width: 100%; height: 500px"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel> -->
    <!-- 轮播图end -->

    <!-- 通知轮播start -->
    <!-- <div class="shop_new">
      <div class="sy_c">
        <div class="sy_gg">
          <div class="shop_new_logo">
            <img th:src="@{/portal/images/new1.png}" />
            <div class="shop_new_text">最新公告</div>
          </div>
          <div class="ranklist">
            <el-carousel direction="vertical" :interval="2000" class="notice_div" indicator-position="none">
              <el-carousel-item v-for="item in notice_list" :key="item">
                 <router-link :to="`siteHelpDetail?itemId=${item.articleId}`" :underline="false" :title="item.articleTitle">{{ item.articleTitle }}</router-link>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="new_more">
              <el-button @click="$router.push('/siteHelp?articleId=2&categoryId=8')" type="danger" icon="el-icon-more" size="small" title="更多"></el-button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 通知轮播 end -->

    <!-- 热门分类层start -->
    <!-- <div class="w w1200">
      <el-row :gutter="20" style="margin: 0 0">
        <el-col
          class="channel-column"
          :span="5"
          v-for="(item, index) in list_hot_Category"
          :key="index + '_hot'"
          :style="
            'background:url(' +
            require('../../assets/images/channel_bg' + (index + 1) + '.jpg') +
            ') no-repeat;'
          "
        >
          <div class="column-title">
            <h3>{{ item.name }}</h3>
            <p>{{ item.remark }}</p>
          </div>
          <div class="column-img">
            <el-image :src="`${item.icon}`" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <router-link :to='`/goodsList?bxscId=${item.bxscId}&bxscName=${item.name}`' class="column-btn">去看看</router-link>
        </el-col>
      </el-row>
    </div> -->
    <!-- 热门分类层end -->

    <!-- 模板1 start -->
    <!-- <div class="wrap1 floor_style_second clearfix">
      <h4 class="floor_title">
        <a href="">美丽人生 FASHION &amp; BEAUTY</a>
      </h4>
      <div class="floor_hotcat">
        <a
          href="https://www.xunyoutest.com/?ctl=Product&amp;met=lists&amp;category_id=2266"
          >香水彩妆</a
        >
        <a
          href="https://www.xunyoutest.com/?ctl=Product&amp;met=lists&amp;category_id=1532"
          >面部清理</a
        >
      </div>
      <div class="floor_content">
        <div class="floor_banner_second">m
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1199"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384205723749.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384205723749.jpg"
              style="display: inline"
          /></a>
        </div>
        <div class="floor_goods">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1177"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578380636753866.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578380636753866.jpg"
              style="display: inline"
          /></a>
          <a
            href="https://www.xunyoutest.com/index.php?mdu=item_id&amp;ctl=Product&amp;met=detail&amp;item_id=1151"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578385100978949.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578385100978949.jpg"
              style="display: inline"
          /></a>
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1112"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578385018573419.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578385018573419.jpg"
              style="display: inline"
          /></a>
          <a
            class="last_item"
            href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=462"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384722393501.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384722393501.jpg"
              style="display: inline"
          /></a>
          <a
            href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=458"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384858503739.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384858503739.jpg"
              style="display: inline"
          /></a>
          <a
            class="max_goods"
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006&amp;"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384215591948.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384215591948.jpg"
              style="display: inline"
          /></a>
          <a
            class="last_item"
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1194"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384949317317.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578384949317317.jpg"
              style="display: inline"
          /></a>
        </div>
      </div>
    </div> -->
    <!-- 模板1 end -->

    <!-- 模板2 start -->
    <!-- <div class="wrap1 floor_style_fourth clearfix">
      <h4 class="floor_title">
        <a
          href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1003"
          >居家生活GROCERY &amp; HEALTH</a
        >
      </h4>
      <div class="floor_hotcat">
        <a
          href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=436"
          >蓝牙</a
        >
        <a
          href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=438"
          >腕机</a
        >
        <a
          href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=440"
          >相机</a
        >
      </div>
      <div class="floor_content">
        <div class="banner1">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1078"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200513/1589349613658733.png"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200513/1589349613658733.png"
              style="display: inline"
          /></a>
        </div>
        <div class="banner2">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1005&amp;"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20191107/1573120884929434.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20191107/1573120884929434.jpg"
              style="display: inline"
          /></a>
        </div>
        <div class="floor_goods">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1210"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379150224426.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379150224426.jpg"
              style="display: inline-block"
          /></a>
          <a
            class="last_item"
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1215"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379511547744.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379511547744.jpg"
              style="display: inline-block"
          /></a>
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1118"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379384311164.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379384311164.jpg"
              style="display: inline-block"
          /></a>
          <a
            class="last_item"
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1216"
            ><img
              data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379658409654.jpg"
              alt="广告图片"
              src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200107/1578379658409654.jpg"
              style="display: inline-block"
          /></a>
        </div>
      </div>
    </div> -->
    <!-- 模板2  end -->

    <!-- 模板3  start -->
    <!-- <div class="wrap1 floor_style_first clearfix">
      <div class="mt fn-clear">
        <div class="floor_title">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=671"
            >品牌活动BRAND ACTIVITY</a
          >
        </div>
        <div class="floor_hotcat">
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006&amp;page=2"
            >品牌闪购</a
          >
          <a
            href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006"
            >今日疯抢</a
          >
        </div>
      </div>
      <div class="mc fn-clear">
        <div class="floor_content">
          <div class="floor_banner">
            <a
              href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=detail&amp;item_id=1194"
              ><img
                data-original="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200721/1595323031109339.jpg"
                alt="广告图片"
                src="https://www.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200721/1595323031109339.jpg"
                style="display: inline"
            /></a>
          </div>
          <div class="floor_goods">
            <div class="block">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=730"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand2.png"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand2.png"
                  style="display: inline"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=731"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand3.png"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand3.png"
                  style="display: inline"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=732"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand4.png"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand4.png"
                  style="display: inline-block"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=733"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand5.png"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand5.png"
                  style="display: inline-block"
              /></a>
            </div>
          </div>
          <div class="floor_cat">
            <div class="block">
              <a
                href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;keywords=%E9%A6%99%E6%B0%B4"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand6.jpg"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand6.jpg"
                  style="display: inline"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;keywords=%E9%A6%99%E6%B0%B4"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand7.jpg"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand7.jpg"
                  style="display: inline"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;keywords=%E9%A6%99%E6%B0%B4"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand8.jpg"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand8.jpg"
                  style="display: inline-block"
              /></a>
            </div>
            <div class="block">
              <a
                href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;keywords=%E9%A6%99%E6%B0%B4"
                ><img
                  data-original="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand9.jpg"
                  alt="广告图片"
                  src="//www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1108_brand9.jpg"
                  style="display: inline-block"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 模板3 end-->
    <!-- <div class="seckill-channel" id="h-seckill">
      <div class="box-hd clearfix">
        <i class="box_hd_arrow"></i>
        <i class="box_hd_dec"
          ><img th:src="@{/portal/images/box_hd_arrow.png}"
        /></i>
        <i class="box-hd-icon"></i>
        <div class="sk-time-cd">
          <div class="sk-cd-tit">距结束</div>
          <div class="cd-time fl" ectype="time" data-time="2017-12-18 10:00:00">
            <div class="days hide">00</div>
            <span class="split hide">天</span>
            <div class="hours">00</div>
            <span class="split">时</span>
            <div class="minutes">00</div>
            <span class="split">分</span>
            <div class="seconds">00</div>
            <span class="split">秒</span>
          </div>
        </div>
        <div class="sk-more">
          <a href="seckill.php" target="_blank">更多秒杀</a>
          <i class="arrow"></i>
        </div>
      </div>
      <div class="box-bd clearfix slideTxtBox">
        <div class="tempWrap hd">
          <ul>
            <li class="opacity_img clone">
              <div class="p-img">
                <a href="#" target="_blank"
                  ><img th:src="@{/portal/images/miaosha0.jpg}"
                /></a>
              </div>
              <div class="p-name">
                <a
                  href="#"
                  target="_blank"
                  title="HLA/海澜之家撞色长袖T恤春季热卖圆领修身拼接T恤男 简约圆领 微弹修身 撞色拼接 触感柔软"
                  >HLA/海澜之家撞色长袖T恤春季热卖圆领修身拼接T恤男 简约圆领
                  微弹修身 撞色拼接 触感柔软</a
                >
              </div>
              <div class="p-over">
                <div class="p-info">
                  <div class="p-price">
                    <span class="shop-price"><em>¥</em>356.00</span>
                    <span class="original-price"><em>¥</em>117.60</span>
                  </div>
                </div>
                <div class="p-btn">
                  <a href="#" target="_blank">立即抢购</a>
                </div>
              </div>
            </li>
            <li class="opacity_img">
              <div class="p-img">
                <a href="#" target="_blank"
                  ><img th:src="@{/portal/images/miaosha0.jpg}"
                /></a>
              </div>
              <div class="p-name">
                <a
                  href="#"
                  target="_blank"
                  title="特大号加厚塑料收纳箱整理箱有盖收纳盒衣服被子置物周转储物箱子"
                  >特大号加厚塑料收纳箱整理箱有盖收纳盒衣服被子置物周转储物箱子</a
                >
              </div>
              <div class="p-over">
                <div class="p-info">
                  <div class="p-price">
                    <span class="shop-price"><em>¥</em>1423.00</span>
                    <span class="original-price"><em>¥</em>240.00</span>
                  </div>
                </div>
                <div class="p-btn">
                  <a href="#" target="_blank">立即抢购</a>
                </div>
              </div>
            </li>
            <li class="opacity_img">
              <div class="p-img">
                <a href="#" target="_blank"
                  ><img th:src="@{/portal/images/miaosha0.jpg}"
                /></a>
              </div>
              <div class="p-name">
                <a
                  href="#"
                  target="_blank"
                  title="74超薄非球面镜片高度近视眼镜片近视镜片防蓝光配眼镜镜片加工 套餐价低至359元 6款镜架任您选"
                  >74超薄非球面镜片高度近视眼镜片近视镜片防蓝光配眼镜镜片加工
                  套餐价低至359元 6款镜架任您选</a
                >
              </div>
              <div class="p-over">
                <div class="p-info">
                  <div class="p-price">
                    <span class="shop-price"><em>¥</em>356.00</span>
                    <span class="original-price"><em>¥</em>478.79</span>
                  </div>
                </div>
                <div class="p-btn">
                  <a href="#" target="_blank">立即抢购</a>
                </div>
              </div>
            </li>
            <li class="opacity_img">
              <div class="p-img">
                <a href="#" target="_blank"
                  ><img th:src="@{/portal/images/miaosha0.jpg}"
                /></a>
              </div>
              <div class="p-name">
                <a
                  href="#"
                  target="_blank"
                  title="南极人法兰绒毛毯加厚秋单人双人珊瑚绒毯子双层冬季被子盖毯 加厚保暖 不掉毛 柔软面料 亲肤透气"
                  >南极人法兰绒毛毯加厚秋单人双人珊瑚绒毯子双层冬季被子盖毯
                  加厚保暖 不掉毛 柔软面料 亲肤透气</a
                >
              </div>
              <div class="p-over">
                <div class="p-info">
                  <div class="p-price">
                    <span class="shop-price"><em>¥</em>1641.00</span>
                    <span class="original-price"><em>¥</em>180.00</span>
                  </div>
                </div>
                <div class="p-btn">
                  <a href="#" target="_blank">立即抢购</a>
                </div>
              </div>
            </li>
            <li class="opacity_img">
              <div class="p-img">
                <a href="#" target="_blank"
                  ><img th:src="@{/portal/images/miaosha0.jpg}"
                /></a>
              </div>
              <div class="p-name">
                <a
                  href="#"
                  target="_blank"
                  title="李军塑料防滑衣架衣挂撑子裤架衣服架成人晾衣架晒衣架子儿童衣架 成人衣架普通 款38cm 50个只要 21元"
                  >李军塑料防滑衣架衣挂撑子裤架衣服架成人晾衣架晒衣架子儿童衣架
                  成人衣架普通 款38cm 50个只要 21元</a
                >
              </div>
              <div class="p-over">
                <div class="p-info">
                  <div class="p-price">
                    <span class="shop-price"><em>¥</em>2423.00</span>
                    <span class="original-price"><em>¥</em>25.20</span>
                  </div>
                </div>
                <div class="p-btn">
                  <a href="#" target="_blank">立即抢购</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <!-- <div class="discount">
      <div class="dis_con">
        <a href="#"><img src="images/discount1.png" /></a>
      </div>
    </div> -->
    <!-- <div class="w1200_container">
      <div class="clear"></div>
      <favoritGoods></favoritGoods> -->
    <!-- <div class="enjoy_title">
        <h3>享品质 享生活</h3>
      </div> -->
    <!-- <div class="enjoy_content">
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info">
                <div class="enjoy1_title">
                  <h4>新品首发</h4>
                  <p>荣耀系列 今日特惠</p>
                </div>
              </div>
              <img src="images/enjoy1.png" class="enter1_enjoy" />
            </div>
          </a>
        </div>
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info" style="background: #dbcf6e">
                <div class="enjoy1_title">
                  <h4>会逛</h4>
                  <p>厨具超级品牌日</p>
                </div>
              </div>
              <img src="images/enjoy2.jpg" class="enter1_enjoy" />
            </div>
          </a>
        </div>
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info" style="background: #534b5d">
                <div class="enjoy1_title">
                  <h4>奢侈大牌</h4>
                  <p>尽享品质生活</p>
                </div>
              </div>
              <img src="images/enjoy3.jpg" class="enter1_enjoy" />
            </div>
          </a>
        </div>
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info" style="background: #3b838c">
                <div class="enjoy1_title">
                  <h4>智能生活</h4>
                  <p>智能潮货，嗨购不停</p>
                </div>
              </div>
              <img src="images/enjoy4.jpg" class="enter1_enjoy" />
            </div>
          </a>
        </div>
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info" style="background: #d58717">
                <div class="enjoy1_title">
                  <h4>京东超市</h4>
                  <p>精选超值好货 天天特价</p>
                </div>
              </div>
              <img src="images/enjoy5.jpg" class="enter1_enjoy" />
            </div>
          </a>
        </div>
        <div class="enjoy_con">
          <a href="#">
            <div class="enjoy_bg">
              <div class="enjoy_info" style="background: #7e5944">
                <div class="enjoy1_title">
                  <h4>积分商城</h4>
                  <p>畅想积分</p>
                </div>
              </div>
              <img src="images/enjoy6.jpg" class="enter1_enjoy" />
            </div>
          </a>
        </div>
      </div> -->
    <!-- <div class="clear"></div> -->
    <!--达人专区-->
    <!-- <div class="enjoy_title">
        <h3>达人专区</h3>
      </div> -->
    <!-- <div class="mastor_con">
        <div
          class="mastor_part"
          style="background: url(images/vip1.jpg); center center no-repeat"
        >
          <div class="master_main">
            <div class="mastor_title">
              <h3>纯棉质品</h3>
              <span>把好货带回家</span>
            </div>
            <a
              href="#"
              class="master_btn"
              target="_blank"
              style="color: #7bd1f6"
              >去见识</a
            >
            <div class="master_img">
              <a href="#" target="_blank">
                <img src="images/vip_shop1.png" />
              </a>
            </div>
          </div>
        </div>
        <div
          class="mastor_part"
          style="background: url(images/vip2.jpg); center center no-repeat"
        >
          <div class="master_main">
            <div class="mastor_title">
              <h3>团购热卖</h3>
              <span>都是好货</span>
            </div>
            <a
              href="#"
              class="master_btn"
              target="_blank"
              style="color: #f75674"
              >去见识</a
            >
            <div class="master_img">
              <a href="#" target="_blank">
                <img src="images/vip_shop2.png" />
              </a>
            </div>
          </div>
        </div>
        <div
          class="mastor_part"
          style="background: url(images/vip3.jpg); center center no-repeat"
        >
          <div class="master_main">
            <div class="mastor_title">
              <h3>团购热卖</h3>
              <span>每一款都是好货</span>
            </div>
            <a
              href="#"
              class="master_btn"
              target="_blank"
              style="color: #ff889e"
              >去见识</a
            >
            <div class="master_img">
              <a href="#" target="_blank">
                <img src="images/vip_shop3.png" />
              </a>
            </div>
          </div>
        </div>
        <div
          class="mastor_part"
          style="background: url(images/vip4.jpg); center center no-repeat"
        >
          <div class="master_main">
            <div class="mastor_title">
              <h3>舒适童鞋</h3>
              <span>帮宝宝走路</span>
            </div>
            <a
              href="#"
              class="master_btn"
              target="_blank"
              style="color: #cd51eb"
              >去见识</a
            >
            <div class="master_img">
              <a href="#" target="_blank">
                <img src="images/vip_shop4.png" />
              </a>
            </div>
          </div>
        </div>
        <div
          class="mastor_part"
          style="background: url(images/vip5.jpg); center center no-repeat"
        >
          <div class="master_main">
            <div class="mastor_title">
              <h3>舒适运动鞋</h3>
              <span>品牌直降</span>
            </div>
            <a
              href="#"
              class="master_btn"
              target="_blank"
              style="color: #43dd72"
              >去见识</a
            >
            <div class="master_img">
              <a href="#" target="_blank">
                <img src="images/vip_shop5.png" />
              </a>
            </div>
          </div>
        </div>
      </div> -->
    <!-- <div class="clear"></div> -->
    <!-- <div class="enjoy_title">
        <h3>店铺推荐</h3>
      </div> -->
    <!-- <div class="good_shop_con">
        <div class="good_shop">
          <a href="#" target="_blank">
            <div class="shop_img">
              <img src="images/good_shop1.png" />
            </div>
            <div class="shop_logo">
              <div class="s_logo">
                <img src="images/shop_logo.png" />
              </div>
              <div class="s_title">
                <p>美宝莲</p>
                <p>纽约高街潮妆</p>
              </div>
            </div>
          </a>
        </div>
        <div class="good_shop">
          <a href="#" target="_blank">
            <div class="shop_img">
              <img src="images/good_shop2.png" />
            </div>
            <div class="shop_logo">
              <div class="s_logo">
                <img src="images/shop_logo1.png" />
              </div>
              <div class="s_title">
                <p>三只松鼠</p>
                <p>就是这个味</p>
              </div>
            </div>
          </a>
        </div>
        <div class="good_shop">
          <a href="#" target="_blank">
            <div class="shop_img">
              <img src="images/good_shop3.png" />
            </div>
            <div class="shop_logo">
              <div class="s_logo">
                <img src="images/shop_logo2.png" />
              </div>
              <div class="s_title">
                <p>绿联旗舰店</p>
                <p>给生活多点精彩</p>
              </div>
            </div>
          </a>
        </div>
        <div class="good_shop">
          <a href="#" target="_blank">
            <div class="shop_img">
              <img src="images/good_shop4.png" />
            </div>
            <div class="shop_logo">
              <div class="s_logo">
                <img src="images/shop_logo3.png" />
              </div>
              <div class="s_title">
                <p>韩都衣舍</p>
                <p>满249减50</p>
              </div>
            </div>
          </a>
        </div>
      </div> -->
    <!-- <div class="clear"></div>
      <div class="enjoy_title">
        <h3>品牌推荐</h3>
      </div>
      <div class="brand_con">
        <div class="brand_left">
          <a href="#" target="_blank">
            <img src="images/brand.jpg" />
          </a>
        </div>
        <div class="brand_right" id="recommend_brands">
          <ul>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (1).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count0">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (2).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count1">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (3).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (4).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (5).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (6).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (7).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (8).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (9).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (10).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (11).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (12).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (13).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (14).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (15).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (16).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (17).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div class="brand_img">
                <a href="#" target="_blank">
                  <img src="images/icon1/brand (18).jpg" />
                </a>
              </div>
              <div class="brand_mash">
                <div class="coupon">
                  <a href="#" target="_blank">
                    关注人数<br />
                    <div id="count2">0</div>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div> -->

    <!-- <div class="enjoy_title">
        <h3>猜你喜欢</h3>
      </div>
      <div class="no_enough">
        <ul>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough1.jpg" />
              </div>
              <div
                class="no_ename"
                title="【情侣款】Camel骆驼男靴 时尚潮流英伦风马丁靴高帮皮靴 爆卖1万双！ 情侣马丁靴 好评如潮"
              >
                【情侣款】Camel骆驼男靴 时尚潮流英伦风马丁靴高帮皮靴 爆卖1万双！
                情侣马丁靴 好评如潮
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough2.jpg" />
              </div>
              <div
                class="no_ename"
                title="春季马丁靴男真皮男靴黄靴工装军靴韩版短靴沙漠靴高帮男鞋大黄靴 头层牛皮"
              >
                春季马丁靴男真皮男靴黄靴工装军靴韩版短靴沙漠靴高帮男鞋大黄靴
                头层牛皮
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough3.jpg" />
              </div>
              <div
                class="no_ename"
                title="特步女鞋2017春季新款运动鞋休闲鞋女慢跑步鞋旅游鞋轻便舒适时尚 早春特惠 爆款休闲女鞋 赠运费险"
              >
                特步女鞋2017春季新款运动鞋休闲鞋女慢跑步鞋旅游鞋轻便舒适时尚
                早春特惠 爆款休闲女鞋 赠运费险
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough4.jpg" />
              </div>
              <div
                class="no_ename"
                title="新款韩版chic学生宽松短款外套上衣字母长袖连帽套头卫衣女潮"
              >
                新款韩版chic学生宽松短款外套上衣字母长袖连帽套头卫衣女潮
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough5.jpg" />
              </div>
              <div
                class="no_ename"
                title="igtt铝框行李箱拉杆箱旅行箱万向轮男女20/24/26寸密码箱登机箱子 铝合金框 加强密码锁 万向轮 终身保修"
              >
                igtt铝框行李箱拉杆箱旅行箱万向轮男女20/24/26寸密码箱登机箱子
                铝合金框 加强密码锁 万向轮 终身保修
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough6.jpg" />
              </div>
              <div
                class="no_ename"
                title="波米铝框拉杆箱万向轮密码旅行箱子20/24寸行李箱女登机箱男26/28 顺丰速运赠运费险赠十礼品终身质保"
              >
                波米铝框拉杆箱万向轮密码旅行箱子20/24寸行李箱女登机箱男26/28
                顺丰速运赠运费险赠十礼品终身质保
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough7.jpg" />
              </div>
              <div
                class="no_ename"
                title="2016秋冬季新款尖头粗跟短靴女高跟真皮加绒中跟马丁靴女靴子女鞋 优质全头层牛皮，品质女鞋"
              >
                2016秋冬季新款尖头粗跟短靴女高跟真皮加绒中跟马丁靴女靴子女鞋
                优质全头层牛皮，品质女鞋
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough8.jpg" />
              </div>
              <div
                class="no_ename"
                title="创意真皮床双人床现代婚床1.8米1.5榻榻米床储物床皮艺床软床大床 床侧储物 升降靠背 双ll价格 更低"
              >
                创意真皮床双人床现代婚床1.8米1.5榻榻米床储物床皮艺床软床大床
                床侧储物 升降靠背 双ll价格 更低
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough9.jpg" />
              </div>
              <div
                class="no_ename"
                title="韩都衣舍2017韩版女装新款黑白拼接插肩棒球服春季短外套HH5597妠 朴信惠同款 黑白拼接 插肩袖 棒球服"
              >
                韩都衣舍2017韩版女装新款黑白拼接插肩棒球服春季短外套HH5597妠
                朴信惠同款 黑白拼接 插肩袖 棒球服
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
          <li class="opacity_img1">
            <a href="#" target="_blank">
              <div class="p_img">
                <img src="images/no_enough10.jpg" />
              </div>
              <div
                class="no_ename"
                title="秋季新款男士套头卫衣印花外套韩版简约百搭潮流男生上衣服"
              >
                秋季新款男士套头卫衣印花外套韩版简约百搭潮流男生上衣服
              </div>
              <div class="no_eprice"><em>¥</em>555.00</div>
            </a>
          </li>
        </ul>
      </div> -->
    <!-- <div class="clear"></div>
    </div> -->
  </div>
</template>
<script type="text/javascript" src="../../assets/js/kuCity.js"></script>
<!-- <script type="text/javascript" th:src="@{/portal/js/jquery.SuperSlide.js}"></script> -->
<script type="text/javascript" src="../../assets/js/slide.js"></script>
<script>
  import {
    deptList,
    deptSave,
    deptDelete
  } from "../../api/userMG";
  import Pagination from "../../components/Pagination";
  import "../../assets/css/base.css";
  import "@/assets/css/style.css";
  import "../../assets/css/slide.css";
  import $ from "jquery";
  import {
    swiperList,
    categoryHotList,
    noticeList,
    getPage
  } from "@/api/xunyou";
  import dataJson from "./pagehme.json";
  import favoritGoods from "@/components/favoritGoods";
  import countDown from "@/components/countDown";
  export default {
    data() {
      return {
        loading: true,
        defaultImg: `this.src='https://www.xunyoutest.com/profile/upload/2021/02/24/dfb444a33aefe4ebc55982f3f2b570ca.jpg'`,//设置错误图片加载
        kill_image: "https://www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1106_brand.png",
        nshow: true, //switch开启
        fshow: false, //switch关闭
        editFormVisible: false, //控制编辑页面显示与隐藏
        imgitems: [], //轮播图
        list_hot_Category: [], //热门分类
        notice_list: [],
        title: "添加",
        editForm: {
          deptId: "",
          deptName: "",
          deptNo: "",
          token: localStorage.getItem("logintoken"),
        },
        // rules表单验证
        rules: {
          deptName: [{
            required: true,
            message: this.$t('index.Please enter a department name'),
            trigger: "blur"
          },],
          deptNo: [{
            required: true,
            message: this.$t('index.Please enter the department code'),
            trigger: "blur"
          },],
        },
        formInline: {
          page: 1,
          limit: 10,
          varLable: "",
          varName: "",
          token: localStorage.getItem("logintoken"),
        },
        // 删除部门
        seletedata: {
          ids: "",
          token: localStorage.getItem("logintoken"),
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          pageNum: 1,
          pageSize: 10,
          total: 10,
        },

        // 装修
        id: 1,
        pageHome: [],
      };
    },
    // 注册组件
    components: {
      Pagination,
      favoritGoods,
      countDown,
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.searchSwiperList(); //轮播图方法
      this.searchCategoryHotList();
      this.searchNoticeList();
      this.getPageInfo();
    },
    // 挂载结束状态(里面是操作)
    mounted() {

      // 		$('.li_dorpdown').hover(function() {
      // 	$('.dorpdown-layer').show();
      // });
      // $('.li_dorpdown').mouseleave(function() {
      // 	$('.dorpdown-layer').hide();
      // });
    },

    updated() {
      this.open2();
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {


      //广告
      open2() {
        //查看是不是又广告位

        this.$notify.closeAll();
        var count = 0;
        this.pageHome.forEach((item) => {
          if (item.ascription == 12) {
            count = 1;
          }
        });
        if (count == 1) {
          // this.$notify({
          //   title: '提示',
          //   message: '这是一条不会自动关闭的消息',
          //   position: 'bottom-right',
          //   duration: 0
          // });
        }
      },
      // 轮播图查询
      searchSwiperList() {
        this.loading = true;
        swiperList()
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.imgitems = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            // this.$message.error(this.$t('index.Carousel failed to load, please try again later!'));
            console.log(err);

          });
      },
      // 热门分类图查询
      searchCategoryHotList() {
        this.loading = true;
        categoryHotList()
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.list_hot_Category = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            // this.$message.error(this.$t('index.Loading failed, please try again later!'));
            console.log(err);

          });
      },
      // 通知查询
      searchNoticeList() {
        this.loading = true;
        var req = {
          articleType: 2,
        };
        noticeList(req)
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.notice_list = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            // this.$message.error(this.$t('index.Loading failed, please try again later!'));
            console.log(err);

          });
      },

      /** ---------------装修接口 开始 ------------------- */
      // 查询接口
      getPageInfo() {
        this.loading = true;
        getPage({
          id: this.id
        })
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              // this.pageHome = dataJson.data;
              this.pageHome = res.data;
              // console.log(this.pageHome,'ccc');
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            // this.$message.error(this.$t('index.Loading failed, please try again later!'));
            console.log(err);

          });
      },
      // 页面数据处理
      // dealData(){
      // },
      /** ---------------装修接口 结束 ------------------- */
    },
  };

</script>

<style scoped lang="less">
  .mylout {
    min-height: 500px;
  }

  /* 广告 */

  .god-wrapper {
    margin: 10px auto 0;
    position: relative;
    width: 1200px;
    max-height: 100px;
  }

  .area {
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0px 0px 10px #ccc;
  }

  .area img {
    /*  width: 100%; */
    display: block;
    margin: 0 auto;
    width: auto !important;
    display: block;
    margin: 0 auto;
    max-height: 100px;
  }

  .god-mark {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 0 5px;
    height: 20px !important;
    text-align: center;
    display: inline-block;
    line-height: 20px;
    color: #fff;
    background-color: rgba(0, 0, 0, .4);
    border-radius: 8px 0 0 0;
    z-index: 1;
  }

  .swf-top {
    background: #fff;
    background-color: #fff;
    filter: alpha(opacity=1);
    -moz-opacity: .01;
    opacity: .01;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    cursor: hand;
    z-index: 1;
  } //广告位end
  img {
    height: -webkit-fill-available !important;
    width: 100% !important;
  }

  /deep/.bgo_home_image {
    width: 100%;
    min-height: 490px;
    height: 0;
    position: relative; // padding-top: 20%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .8)
  }

  /deep/.bgo_home_image img {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
  } //秒杀
  .skill_act_pic {
    width: -webkit-fill-available;
    height: 195px;
    overflow: hidden;
    padding: 10px;
  }

  .skill_act_name {
    width: 166px;
    line-height: 30px;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 10px 28px;
  }

  .skill_act_price {
    width: 165px;
    height: 30px;
    margin: 10px 28px;
  }

  .skill_act_price .act_now_price {
    display: inline-block;
    width: 80px;
    text-align: center;
    color: #fff;
    line-height: 28px;
    height: 28px;
    border: 1px solid #c11045;
    background: #c11045;
  }

  .skill_act_price .act_old_price {
    display: inline-block;
    width: 80px;
    text-align: center;
    line-height: 28px;
    height: 28px;
    background: #fff;
    text-decoration: line-through;
    border: 1px solid #c11045;
    color: #8f8f8f;
  } //平团
  .grid-content-spell {
    border-radius: 4px;
    min-height: 423px;
  }

  .spell_goods_pic {
    width: -webkit-fill-available;
    height: 200px;
    overflow: hidden;
    padding: 28px;
  }

  .act_info {
    width: 100%;
    height: 60px;
    background: #c11045; // padding: 10px 0px;
    padding: 10px 10px;
    box-sizing: border-box;
    color: #FFF;
    position: relative;
    font-size: 12px;
    line-height: 18px;
  }

  .act_info span {
    display: inline-block;
    width: 18px;
    height: 18px;
    text-align: center;
    background: #FFF;
    border-radius: 5px;
    color: #c11045;
    line-height: 18px;
  }

  .act_info p {
    margin-bottom: 2px;
  }

  .act_info .buy_cart {
    position: absolute;
    width: 120px;
    height: 30px;
    right: 0px;
    top: 0px;
    background: url(../../assets/images/buy_cart.png);
    top: 15px;
  }

  .pname {
    width: 100%;
    height: 55px;
    margin-top: 10px;
    position: relative;
  }

  .pname .name {
    width: 185px;
    margin: 15px;
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    text-align: left;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #333;
  }

  .pname .price {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 18px;
    line-height: 28px;
    height: 28px;
    color: #c11045;
    font-weight: bold;
  }

  .percentBar {
    width: 250px;
    margin: 0px 15px;
  }

  .percentBar .barWrap {
    width: 100%;
    height: 8px;
    border: 6px;
    border: 1px solid #ffa9c3;
    border-radius: 8px;
    position: relative;
  }

  .percentBar .barWrap b {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #ffa9c3;
  }

  b,
  strong {
    font-weight: 700 !important;
  } //楼层模板1114
  .grid-content-1114 {
    border-radius: 4px;
    min-height: 460px;
  }

  .goods_pic_1114 {
    width: -webkit-fill-available;
    height: 460px;
    overflow: hidden;
  } //公用
  /deep/.el-image div.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #d3dce638;
    color: #909399;
    font-size: 40px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
  }

  .bg {
    width: 100%;
    height: 100%;
    cursor: pointer;
  } //提示框
  /deep/.el-notification.right {
    right: 55px;
  }

  /deep/.el-notification {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 96%;
    padding: 14px 26px 14px 13px;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #EBEEF5;
    position: fixed;
    background-color: #FFF;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    -webkit-transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s;
    transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    overflow: hidden;
  } // .left_bar {
  //     width: 230px;
  //     height: 336px;
  //     background-image: url(../images/index/skill.png);
  //     float: left;
  //     margin-right: 2px;
  //     position: relative;
  // }
  /* .carouselBox.el-carousel.el-carousel--horizontal {
    width: calc(100% - 40px);
  } */

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .bg-purple {
    // background: #d3dce638;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  }

  .grid-content {
    border-radius: 4px;
    min-height: 330px;
  }

  .el-col-5 {
    width: 20%;
  }

  /* 热门分类 start*/

  .column-title {
    text-align: center;
    color: #fff;
    min-height: 82px;
    overflow: hidden;
  }

  .channel-column {
    width: 230px;
    height: 330px;
    float: left;
    margin-right: 10px;
    position: relative;
    z-index: 1;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
  }

  .column-img {
    width: 155px;
    height: 155px;
    margin: 20px auto 0;
  }

  .column-btn {
    display: block;
    width: 140px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    border-radius: 20px;
    background-color: #fff;
    position: absolute;
    bottom: 17px;
    left: 46px;
    -webkit-transition: all 150ms ease-in-out;
    transition: all 150ms ease-in-out;
  }

  /* 热门分类 end*/

  /* 公告通知 start */

  .notice_div {
    height: 100%;
    line-height: 50px;
    font-size: 16px;
  }

  /deep/.notice_div .el-carousel__container {
    height: 100%;
  }

  /* 公告通知 end */
</style>


// WEBPACK FOOTER //
// src/views/dashboard/main.vue